import * as element from "@wordpress/element";
import React from "react";
const { createRoot, render } = wp.element as typeof element;

export const renderer = (Component: React.FC, root: HTMLElement) => {
	if (createRoot) {
		createRoot(root).render(<Component />);
	} else {
		render(<Component />, root);
	}
};
